import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { createSocialButton } from '@fs/identity.js'
import { QRCodeSVG } from 'qrcode.react'
import { useOverlay } from '@fs/zion-ui'
import QrDialog from './QrDialog'

const baseButtonCss = css`
  text-transform: none !important;
  display: flex !important;
  align-items: center;
  white-space: normal;
`

const floatCss = css`
  float: left; // inline-start not supported on most browsers
  html[dir='rtl'] & {
    float: right;
  }
`
const qrButtonCss = css`
  & > #qr-code {
    ${baseButtonCss}
  }
`

const iconCss = css`
  ${floatCss}
  width: 28px;
  margin-inline-start: -10px;
  padding-inline-end: 2px;
`

// Define QrIcon as a function component, not as an element
const QrIcon = () => (
  <QRCodeSVG
    value="https://www.familysearch.org/en/help/helpcenter/article/how-do-i-sign-in-to-familysearch"
    title="FamilySearch"
    size={28}
    bgColor="#ffffff"
    fgColor="#000000"
    level="L"
    css={iconCss}
    aria-label="QR code to sign in to FamilySearch"
  />
)

export default function QrLoginButtonComponent() {
  const { t } = useTranslation()
  const overlay = useOverlay()

  const QrLoginButton = createSocialButton({ provider: 'qrcode', Icon: QrIcon, css: qrButtonCss })

  return (
    <>
      <QrLoginButton onClick={overlay.handleClick} text={t('login.use-my-phone', 'Use My Phone')} id="qr-code" />
      <QrDialog overlay={overlay} />
    </>
  )
}
